import { ReactComponent as TriangleAlert } from "assets/images/iconsV2/triangle-alert.svg";
import Badge from "components/v2/Badge/Badge";

import "./MissingStopsWarningBadge.scss";

interface MissingStopsWarningBadgeProps {
  message: string;
}

export default function MissingStopsWarningBadge({ message }: MissingStopsWarningBadgeProps) {
  return (
    <div className="rfv2-missing-stops-warning-badge">
      <Badge
        type="category-badge"
        color="warning"
        size="sm"
        variant="icon-leading"
        icon={<TriangleAlert className="rfv2-missing-stops-warning-badge__icon" />}
        label={message}
      />
    </div>
  );
}
